var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.getDivClass,attrs:{"messenger_app_id":_vm.getMessengerId,"page_id":_vm.getFbPgId,"data-ref":_vm.instanceId,"color":"blue","size":"xlarge"}})}
var staticRenderFns = []

export { render, staticRenderFns }